var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{class:_vm.classes,attrs:{"for":_vm.labelFor,"title":_vm.title}},[_vm._t("default"),_vm._v(" "),(_vm.required)?_c('sup',{staticClass:"text-danger",attrs:{"dusk":`${_vm.labelFor}-asterisk`}},[_vm._v("*")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }